module.exports = __webpack_public_path__ + "/login_ui/img/co-b6414e08050729e50511173a2d2a6a56.svg";